import { ReactSVG } from 'react-svg'

import { useAuthFlow } from '@features/auth'
import { useAuth } from '@features/auth/provider'


import { formatPhoneNumber } from '@widgets/personal/profile/lib/helpers'

import { URL_CUSTOMER_PROFILE } from '@shared/contants'
import { cn } from '@shared/lib/cn'
import { useLocalizedNavigate as useNavigate } from '@shared/lib/locale'
import Button from '@shared/ui/button'
import Wrapper from '@shared/ui/wrapper'


import styles from './styles.module.scss'



export default function PersonalProfile () {
  const { user } = useAuth()
  const navigate = useNavigate()
  const authFlow = useAuthFlow(() => navigate(URL_CUSTOMER_PROFILE))
  const isActive = location.pathname === URL_CUSTOMER_PROFILE

  return (
    <Wrapper
      className={cn(styles.root, {
        [styles['root--active']]: isActive,
      })}
    >
      <ReactSVG src={'/icons/user.svg'} className={styles.root__icon} />
      <span className={styles.root__name}>{user?.first_name} </span>
      {user?.phone && (
        <span className={styles.root__phone}>
          {formatPhoneNumber(user?.phone)}
        </span>
      )}
      <Button
        className={styles.root__button}
        onClick={authFlow}
        theme="grey"
        size="small"
      >
        <ReactSVG src="/icons/arrow-right.svg" wrapper="span" />
      </Button>
    </Wrapper>
  )
}
